function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { spacing } from "./spacing";
var largeSizes = {
  max: "max-content",
  min: "min-content",
  full: "100%",
  "3xs": "12rem",
  "2xs": "16rem",
  xs: "20rem",
  sm: "25rem",
  md: "28rem",
  lg: "32rem",
  xl: "38rem",
  "2xl": "42rem",
  "3xl": "50rem",
  "4xl": "56rem",
  "5xl": "64rem",
  "6xl": "70rem",
  "7xl": "80rem",
  "8xl": "90rem"
};
var percentages = {
  "10p": "10%",
  "80p": "80%"
};
var container = {
  sm: "40rem",
  md: "48rem",
  lg: "64rem",
  xl: "80rem"
};

var sizes = _extends({}, spacing, largeSizes, percentages, {
  container
});
/**
 * @deprecated
 * You can derive the Sizes type from the DefaultChakraTheme
 *
 * type Sizes = DefaultChakraTheme['sizes']
 */


export default sizes;
//# sourceMappingURL=sizes.js.map